import { RESOURCE } from '@src/constants';
import { ERROR_CODE } from '@src/errors/code';
import api from './api';

export const createSynthesis = async (
  payload,
  { recaptchaToken, turnstileToken },
) => {
  const data = { ...payload };
  if (payload.volume) delete data.volume;

  try {
    const response = await api({
      method: 'POST',
      url: RESOURCE.SYNTHESIS,
      data,
      headers: {
        'recaptcha-token': recaptchaToken || '',
        'turnstile-token': turnstileToken || '',
      },
    });

    return response;
  } catch (error) {
    return { status: 0, errorCode: ERROR_CODE.BAD_REQUEST };
  }
};
export const createSynthesisMultiBlock = async (
  payload,
  { recaptchaToken, turnstileToken },
) => {
  const data = { ...payload };
  if (payload.volume) delete data.volume;

  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.PROJECTS}${RESOURCE.SYNTHESIS}`,
      data,
      headers: {
        'recaptcha-token': recaptchaToken || '',
        'turnstile-token': turnstileToken || '',
      },
    });

    return response;
  } catch (error) {
    return { status: 0, errorCode: ERROR_CODE.BAD_REQUEST };
  }
};
